"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = exports.SelectorType = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Selector = require("./Selector.style");

var _helpers = require("../../utils/helpers");

var SelectorType = {
  Checkbox: 'checkbox',
  Radio: 'radio'
};
exports.SelectorType = SelectorType;

var Selector = function Selector(_ref) {
  var name = _ref.name,
      label = _ref.label,
      checked = _ref.checked,
      inputType = _ref.inputType,
      onChangeCallback = _ref.onChangeCallback,
      rest = _objectWithoutProperties(_ref, ["name", "label", "checked", "inputType", "onChangeCallback"]);

  var idRef = (0, _react.useRef)((0, _helpers.getUniqueID)());
  return /*#__PURE__*/_react.default.createElement(_Selector.SelectorWrapper, null, /*#__PURE__*/_react.default.createElement(_Selector.Input, Object.assign({
    id: idRef.current,
    name: name,
    checked: checked,
    type: inputType,
    onChange: onChangeCallback
  }, rest)), label && /*#__PURE__*/_react.default.createElement(_Selector.Label, {
    htmlFor: idRef.current
  }, label));
};

Selector.propTypes = {
  name: _propTypes.default.string,
  label: _propTypes.default.string.isRequired,
  checked: _propTypes.default.bool,
  inputType: _propTypes.default.oneOf(Object.values(SelectorType)),
  onChangeCallback: _propTypes.default.func
};
Selector.defaultProps = {
  name: '',
  checked: false,
  inputType: SelectorType.Checkbox,
  onChangeCallback: function onChangeCallback() {}
};
var _default = Selector;
exports.default = _default;